module.exports = __webpack_public_path__ + "static/perfect-7c18ed8d03b6c3de6c37c20a5235f135.jpg";